// components/Inputs/NumberInput.jsx
import { Input } from "antd";
import { getIn } from "formik";

const NumberInput = ({
  name,
  label,
  placeholder,
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
}) => {
  const value = getIn(values, name);
  const error = getIn(errors, name);
  const isTouched = getIn(touched, name);
  const hasError = error && isTouched;

  return (
    <div>
      {label && (
        <label className="block mb-1 text-sm font-medium text-gray-700">
          {label}
        </label>
      )}
      <Input
        type="number"
        name={name}
        value={value || ""}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        className={hasError ? "border border-red-500" : ""}
      />
      {hasError && <div className="text-red-500 text-xs mt-1">{error}</div>}
    </div>
  );
};

export default NumberInput;
